export function validSeasonSelection(seasons, selectedSeasonId) {
    if (seasons.some((season) => season.id === selectedSeasonId)) {
        return selectedSeasonId;
    }
    return (seasons.find((season) => season.is_active) || seasons[0])?.id || "";
}
